/// <amd-module name="Wit/WorkItemForm/Attachments/useAttachmentUri" />
import { IVssPageContext } from "VSS/Platform/Context";
import { usePageContext } from "VSS/Platform/Layout";
import { RestClientBase } from "VSS/Platform/RestClientBase";
import { Uri, replaceRouteValues } from "VSS/Platform/Util/Url";
import { getWorkItemTrackingClient } from "Wit/Clients/Wit/RestClient/WorkItemTracking";
import { ILinkInfo } from "Wit/WorkItemDataManager/Contracts";
import { useEffect, useState } from "react";
import { useWorkItem } from "../Common/Hooks";

const attachmentContentRoutePattern = "/{project}/_apis/wit/attachments/{id}";
let rootPathPromise: Promise<string> | undefined = undefined;
type AttachmentUriParams = { download?: boolean; fileName?: string; "api-version"?: string };

export function useAttachmentUri(attachment: ILinkInfo, params?: AttachmentUriParams): string | undefined {
    const [src, setSrc] = useState<string>();
    const project = useWorkItem().project.guid;
    const pageContext = usePageContext();

    useEffect(() => {
        setSrc(undefined);
        getAttachmentUri(pageContext, project, attachment, params).then(setSrc);
    }, [pageContext, attachment]);

    return src;
}

export async function getAttachmentUri(
    pageContext: IVssPageContext,
    project: string,
    attachment: ILinkInfo,
    params?: AttachmentUriParams
): Promise<string> {
    if (!rootPathPromise) {
        const witClient = getWorkItemTrackingClient(pageContext);
        // Note: Unsafe - we don't technically have any guarantees that the IWorkItemTrackingRestClient is a RestClientBase
        rootPathPromise = (witClient as unknown as RestClientBase).getRootPath();
    }
    const rootPath = await rootPathPromise;
    let attachmentPath = replaceRouteValues(attachmentContentRoutePattern, {
        project,
        id: attachment.FilePath
    });
    if (rootPath.length > 0 && rootPath[rootPath.length - 1] === "/") {
        attachmentPath = attachmentPath.substr(1);
    }
    if (params) {
        const uri = new Uri(rootPath + attachmentPath);
        uri.addQueryParams(params);
        return uri.absoluteUri;
    }
    return rootPath + attachmentPath;
}
